'use strict';

import '../css/cookie-settings.scss'
import { getCookieConsent, hasConsentFor } from './cookie-consent.js'

document.addEventListener('DOMContentLoaded', () => {
    const analytics = document.querySelector('#cookie-analytics')
    const advertising = document.querySelector('#cookie-advertising')

    // Предзаполняем чекбоксы текущим согласием, если cookie уже существует.
    const consent = getCookieConsent()
    if (consent) {
        if (analytics) analytics.checked = hasConsentFor('analytics')
        if (advertising) advertising.checked = hasConsentFor('advertising')
    }

    const form = document.querySelector('.cookie-settings')
    if (!form) return

    form.addEventListener('submit', (e) => {
        e.preventDefault()

        const categories = ['necessary']
        if (analytics && analytics.checked) categories.push('analytics')
        if (advertising && advertising.checked) categories.push('advertising')

        // Обращение через window.st вместо голого идентификатора:
        // при незагруженном основном бандле не бросит ReferenceError.
        if (window.st && window.st.privacyPolicy) {
            window.st.privacyPolicy.accept(categories.join(','))
        }

        window.location.reload()
    })
})
